import React from 'react';

function ShowError(props) {
    return (
        <div>
            Some of the information is missing
        </div>
    );
}

export default ShowError;